import { AbstractPmsApiService } from './abstract.service';
import { SubscriptionCreditNote } from '../models';

/**
 * @class SubscriptionCreditNotePmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<SubscriptionCreditNote>}
 */
export class SubscriptionCreditNotePmsApiService extends AbstractPmsApiService {

    /**
     * @type {string[]}
     */
    static get $inject() {
        return super.$inject.concat([
            'DownloadFile'
        ]);
    }

    /**
     * @param {$http} http
     * @param {ConfigPmsApiService} config
     * @param {EventsBrokerPmsApiService} eventsBroker
     * @param {DownloadFile} DownloadFile
     */
    constructor(http, config, eventsBroker, DownloadFile) {

        super(http, config, eventsBroker);

        this.DownloadFile = DownloadFile;

    }

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/subscription/:subscriptionId/credit-note(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {SubscriptionCreditNote}
     * @protected
     */
    newModel(attributes, ...params) {

        return new SubscriptionCreditNote(attributes);
    }

    /**
     * @param {Subscription} subscription
     * @param {Object=} params
     * @returns {Promise.<PaginationCollection<SubscriptionCreditNote>>}
     */
    get(subscription, params = {}) {

        const url = this.url({subscriptionId: subscription.id});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {SubscriptionCreditNote} creditNote
     * @param {String} lang
     * @returns {Promise.<SubscriptionCreditNote>}
     */
    create(creditNote, lang) {

        const url = this.url({subscriptionId: creditNote.subscription_id});

        const model = creditNote.toObject();

        model.lang = lang;

        return this.http
            .post(url, model, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {SubscriptionCreditNote} creditNote
     *
     * @returns {Promise.<*>}
     */
    getPdf(creditNote) {

        const url = this.url({
            subscriptionId: creditNote.subscription_id,
            id: creditNote.id,
        }) + '/pdf';

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(({ data }) => {

                this.DownloadFile.fetchFile(data.url, creditNote.ident);
            })
            .catch(this.getErrorHandler());

    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/subscription-credit-note.service.js